import { render, staticRenderFns } from "./FormComplaintlocal.vue?vue&type=template&id=3ad8bba6&"
import script from "./FormComplaintlocal.vue?vue&type=script&lang=js&"
export * from "./FormComplaintlocal.vue?vue&type=script&lang=js&"
import style0 from "./FormComplaintlocal.vue?vue&type=style&index=0&id=3ad8bba6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports